// extracted by mini-css-extract-plugin
export var closeButton = "_dn-1";
export var closeX = "_dn-3";
export var container = "_dn-0";
export var image = "_dn-2";